<template>
  <div :class="appbarClass">
    <slot></slot>
  </div>
</template>

<script>
import { appbarClass } from "../prefix";
export default {
  computed: {
    appbarClass() {
      return appbarClass;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-appbar";

#{$element} {
  background: $theme-primary;
  height: 56px;
  padding: 4px 8px;
  @include elevation(3);
  position: relative;

  #{$element}-title {
    line-height: 48px;
    color: white;
    font-weight: 300;
    float: left;
    padding: 0 4px;
  }
}
</style>
